import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy border-t border-white/10 py-4 px-4 text-center text-gray-500 text-xs" data-id="element-36">
      <p data-id="element-37">
        © {currentYear} Pack Reconexión Familiar Total™. Todos los derechos
        reservados.
      </p>
    </footer>;
}